import withCrmCompanyGate from 'hocs/withCrmCompanyGate';

import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class CrmPaths {
  static crm = new EnhancedPath('/crm');

  static contactList = new EnhancedPath('/crm');

  static crmTags = new EnhancedPath(`${CrmPaths.crm.path}/tags`);

  static leadAssignmentRules = new EnhancedPath(`${CrmPaths.crm.path}/lead-assignment-rules`);

  static contactDetail = new EnhancedPath(`${CrmPaths.crm.path}/contacts/:contactId`);

  static contactActivities = new EnhancedPath(
    `${CrmPaths.crm.path}/contacts/:contactId/activities/:subtab?`,
  );

  static leadWorkspace = new EnhancedPath(`${CrmPaths.crm.path}/leads/:applicationId`);
}

const crmRoutesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: CrmPaths.crmTags.path,
      component: withCrmCompanyGate(lazyWithRetry(() => import('app/pages/system/crmTags'))),
      pageCode: PAGE_CODES.CRM_TAGS,
    },
    {
      path: CrmPaths.leadAssignmentRules.path,
      component: withCrmCompanyGate(
        lazyWithRetry(() => import('app/pages/crm/leadAssignmentRules')),
      ),
      pageCode: PAGE_CODES.USERS_LEAD_ASSIGNMENT,
    },
    // Deliberately carries NO pageCode. Every lead-stage application is force-redirected
    // here from the loan editor, so a permission gate on this route has no fallback: the
    // layout guard renders the 403 page before LeadWorkspacePage mounts, and its own
    // redirect (back to the loan editor when the company disabled CRM) never runs.
    // crm.contacts.view/.edit are granted to zero roles (DEV-6253), so gating this route
    // locked every non-admin user out of every lead in production (DEV-6824).
    {
      path: CrmPaths.leadWorkspace.path,
      component: lazyWithRetry(() => import('app/pages/crm/leadWorkspace')),
    },
    {
      path: CrmPaths.contactActivities.path,
      component: withCrmCompanyGate(lazyWithRetry(() => import('app/pages/crm/contactDetail'))),
      pageCode: PAGE_CODES.CRM_CONTACTS,
    },
    {
      path: CrmPaths.contactDetail.path,
      component: withCrmCompanyGate(lazyWithRetry(() => import('app/pages/crm/contactDetail'))),
      pageCode: PAGE_CODES.CRM_CONTACTS,
    },
    {
      path: CrmPaths.contactList.path,
      exact: true,
      component: withCrmCompanyGate(lazyWithRetry(() => import('app/pages/crm/contactList'))),
      pageCode: PAGE_CODES.CRM_CONTACTS,
    },
  ],
};

export default crmRoutesConfig;
